import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useHistory } from 'react-router'
import Spinner from 'react-spinkit'
import { useAuth } from '../../contexts/AuthContext'
import { GenerateRandomNumber, UpdateDocument } from '../../firebase/firebase'
export default function AddTikTok({ match }) {
    const { path } = match
    const { currentUser, logout, userRole } = useAuth()
    const [user, setUser] = useState('')
    const [loading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)
    const history = useHistory()
    



    const [tikTok, setTikTok] = useState({
        title: "",
        url: "",
        type: 'tikTok'

    })

    

    const onChange = (e) => {
        setTikTok({ ...tikTok, [e.target.name]: e.target.value })
        console.log(tikTok)

    }

    const handleCancel = (e) => {
        history.push('/admin')
    }

    const handleSubmit = async (e) => {
        const form = e.currentTarget
        if (form.checkValidity() === false) {
            console.log('need val')
            e.preventDefault()
            e.stopPropagation()
        }
        setValidated(true)
        e.preventDefault()


        try {
            setLoading(true)
            let tikTokToUpload = { ...tikTok }
            tikTokToUpload.id = GenerateRandomNumber()


            await UpdateDocument('media', tikTokToUpload, false)
            history.push(`/admin`)
            


        }

        catch (e) {
            alert(`Error " ${e.message}`)

        }
        setLoading(false)
    }
    return (
        <>

            {loading ?
                <Container style={{ top: '0', position: 'absolute' }} fluid className='min-vh-100 d-flex flex-grow-1'>
                    <Row className="justify-content-center flex-grow-1">
                        <Col className='d-flex justify-content-center align-items-center'>
                            <Spinner className="d-flex flex-wrap align-items-center mx-0 px-0" name='ball-pulse-sync' />
                        </Col>
                    </Row>
                </Container>
                :
                <Container fluid className='pt-5'>

                    <Row className="justify-content-md-center">
                        <Col lg={6}>
                            <Card>
                                <Form validated={validated} onSubmit={handleSubmit}>
                                    <Card.Header>
                                        Add a Tik Tok
                                    </Card.Header>
                                    
                                    <Card.Body>
                                        <Row className="mb-3">
                                            <Form.Control

                                                onChange={onChange}
                                                type="text"
                                                required
                                                placeholder="Title"
                                                value={tikTok.title}
                                                name='title'
                                            />



                                        </Row>

                                        <Row className="mb-3">
                                            <Form.Control
                                                required
                                                onChange={onChange}
                                                type="text"
                                                placeholder="URL"
                                                value={tikTok.url}
                                                name='url'
                                            />



                                        </Row>
                                        
                                        <Row xl={6}>
                                            <Col>
                                                <Button type="submit">Create</Button>
                                            </Col>
                                            <Col>
                                                <Button type='button' variant="secondary" onClick={handleCancel}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>

                                    </Card.Body>
                                </Form>
                            </Card>

                        </Col>
                    </Row>
                </Container>
            }

        </>
    )
}